const liff = {
    error: '',
    ready: true,
    init: async () => {},
    openWindow: async () => {},
    shareTargetPicker: async () => {},
    getDecodedIDToken: () => ({ phone_number: '0912345678' }),
    isLoggedIn: () => true,
    isInClient: () => false,
    getFriendship: async () => ({ friendFlag: false }),
    getProfile: async () => ({
        userId: 'U1bb8c428b1c8945bbf5f7a82374d0735',
        displayName: '黃卷 Juan',
        statusMessage: 'じゅえん',
        pictureUrl:
            'https://profile.line-scdn.net/0hDLs-FdmaG2NeVDCtltNlHC4EGAl9JUJxcDRVBWJWTAZgNloycTdVBmNSQVQxbVticjVSAG5QElRSR2wFQALnV1lkRVRnYFg2ezNUhg'
    }),
    getAccessToken: () =>
        'eyJhbGciOiJIUzI1NiJ9.cIkdI3b7GkCB1F-wIeN6WTUnNTdKC7zBNqZ9Z2L-2xqcTCBhrvZStnikUqNivAnbHyNfyMNEiPqr2nXsKf7jGcpnwGyxh9gCE1aOXiDRCy84tDcxAlBmZ02QH09rKq9zuyGb1XSOmlqKP7UPjOH7XCsLAPvMKsIKeysZrIaU8c8.JZrVx9bL-VjBxZ3pN8RZQa5WLloqFs562d8E7U4R6N0'
};

export default liff;
